/**
 * Hosts where non-production-only behavior is allowed (the `/style-guide` and `/cms-zones`
 * routes, CMS visibility overrides). Kept out of the component file so non-component modules
 * can import it without tripping the fast-refresh rule.
 */
const NON_PROD_ALLOWED_ORIGINS = [
    'http://localhost',
    'https://localhost',
    'https://local.kuder.io',
];

const NON_PROD_ALLOWED_HOSTS = [
    'local.kuder.io',
    'labs.kuder.io', // e.g. dv.labs.kuder.io
    'stg.np.kuder.io', // staging
];

export function isNonProdOrigin(origin: string, hostname: string): boolean {
    if (NON_PROD_ALLOWED_ORIGINS.some(prefix => origin.startsWith(prefix))) {
        return true;
    }
    return NON_PROD_ALLOWED_HOSTS.some(host => hostname.endsWith(host) || hostname === host);
}

/**
 * Convenience wrapper reading the current window location. False during a server render: the
 * non-prod affordances it gates (visibility overrides, diagnostics routes) are browser-only,
 * and a server render must never vary on them.
 */
export function isNonProdHost(): boolean {
    if (typeof window === 'undefined') return false;
    const { origin, hostname } = window.location;
    // Some tests replace `window.location` with a partial stub (`{ href: '' }`). Treat a
    // missing origin as production so visibility overrides stay off instead of throwing.
    if (!origin || !hostname) return false;
    return isNonProdOrigin(origin, hostname);
}
